import { render, staticRenderFns } from "./IconRadioOn.vue?vue&type=template&id=3c2ae64a&"
import script from "./IconRadioOn.vue?vue&type=script&lang=js&"
export * from "./IconRadioOn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports